// import React, { useEffect, useMemo, useState } from "react";
// import { Box, Typography, Chip, IconButton, Tooltip, Tabs, Tab, CircularProgress, Alert } from "@mui/material";
// import { MaterialReactTable } from "material-react-table";
// import { useDispatch, useSelector } from "react-redux";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import DownloadIcon from "@mui/icons-material/Download";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import PhoneIcon from "@mui/icons-material/Phone";
// import ApiIcon from "@mui/icons-material/Api";
// // import WebhookIcon from "@mui/icons-material/Webhook"; // Webhook functionality commented out
// import ErrorIcon from "@mui/icons-material/Error";
// import { setModal } from "../../features/modal/ModalSlice";
// import CustomButton from "../../components/Button/CustomButton";
// import apiClient from "../../services/apiClient";
// import toast from "react-hot-toast";

// const Logs = () => {
//   const dispatch = useDispatch();
//   const modal = useSelector((state) => state.modal?.modal);
//   const [activeTab, setActiveTab] = useState(0);

//   // Dynamic Call Logs State
//   const [callLogs, setCallLogs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Call Logs Pagination state
//   const [callLogsPagination, setCallLogsPagination] = useState({
//     pageIndex: 0,
//     pageSize: 10,
//   });
//   const [callLogsPaginationInfo, setCallLogsPaginationInfo] = useState({
//     total_count: 0,
//     total_pages: 0,
//   });

//   // Dynamic Error Logs State
//   const [errorLogsData, setErrorLogsData] = useState([]);
//   const [errorLogsLoading, setErrorLogsLoading] = useState(false);

//   // Error Logs Pagination state
//   const [errorLogsPagination, setErrorLogsPagination] = useState({
//     pageIndex: 0,
//     pageSize: 10,
//   });
//   const [errorLogsPaginationInfo, setErrorLogsPaginationInfo] = useState({
//     total_count: 0,
//     total_pages: 0,
//   });

//   // Dynamic API Logs State
//   const [apiLogs, setApiLogs] = useState([]);
//   const [apiLogsLoading, setApiLogsLoading] = useState(false);

//   // API Logs Pagination state
//   const [apiLogsPagination, setApiLogsPagination] = useState({
//     pageIndex: 0,
//     pageSize: 10,
//   });
//   const [apiLogsPaginationInfo, setApiLogsPaginationInfo] = useState({
//     total_count: 0,
//     total_pages: 0,
//   });

//   // Call Log Details Loading State
//   const [loadingDetails, setLoadingDetails] = useState(false);

//   // Webhook functionality commented out
//   // const [webhookLogs] = useState([
//   //   {
//   //     id: 1,
//   //     timestamp: "2024-01-15 11:45:30",
//   //     event: "call.started",
//   //     url: "https://api.company.com/webhooks/vapi",
//   //     statusCode: 200,
//   //     responseTime: "456ms",
//   //     retries: 0,
//   //   },
//   //   {
//   //     id: 2,
//   //     timestamp: "2024-01-15 11:38:15",
//   //     event: "call.ended",
//   //     url: "https://api.company.com/webhooks/vapi",
//   //     statusCode: 200,
//   //     responseTime: "523ms",
//   //     retries: 0,
//   //   },
//   //   {
//   //     id: 3,
//   //     timestamp: "2024-01-15 11:30:42",
//   //     event: "assistant.message",
//   //     url: "https://webhook.company.com/messages",
//   //     statusCode: 500,
//   //     responseTime: "1205ms",
//   //     retries: 2,
//   //   },
//   //   {
//   //     id: 4,
//   //     timestamp: "2024-01-15 11:25:18",
//   //     event: "call.started",
//   //     url: "https://api.company.com/webhooks/vapi",
//   //     statusCode: 200,
//   //     responseTime: "387ms",
//   //     retries: 0,
//   //   },
//   //   {
//   //     id: 5,
//   //     timestamp: "2024-01-15 11:15:55",
//   //     event: "tool.executed",
//   //     url: "https://tools.company.com/webhook",
//   //     statusCode: 404,
//   //     responseTime: "89ms",
//   //     retries: 3,
//   //   },
//   // ]);


//   // Fetch Call Logs from API
//   useEffect(() => {
//     fetchCallLogs();
//   }, [callLogsPagination.pageIndex, callLogsPagination.pageSize]);

//   // Fetch API Logs when tab changes to API Logs
//   useEffect(() => {
//     if (activeTab === 1) {
//       fetchApiLogs();
//     }
//   }, [activeTab, apiLogsPagination.pageIndex, apiLogsPagination.pageSize]);

//   // Fetch Error Logs when tab changes to Error Logs
//   useEffect(() => {
//     if (activeTab === 2) {
//       fetchErrorLogs();
//     }
//   }, [activeTab, errorLogsPagination.pageIndex, errorLogsPagination.pageSize]);

//   useEffect(() => {
//     if (modal?.isUpdatedIn === "LOGS") {
//       fetchCallLogs();
//       if (activeTab === 1) {
//         fetchApiLogs();
//       }
//       if (activeTab === 2) {
//         fetchErrorLogs();
//       }
//     }
//   }, [modal, activeTab]);

//   const fetchCallLogs = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const response = await apiClient.get("/call-logs", {
//         page: callLogsPagination.pageIndex + 1,
//         page_size: callLogsPagination.pageSize,
//       });

//       if (response.status && response.data) {
//         // Map API response to UI format
//         const formattedLogs = response.data.map((log) => ({
//           id: log._id,
//           timestamp: log.timestamp || log.created_at,
//           callId: log.call_id,
//           assistant: log.assistant,
//           phoneNumber: log.phone_number,
//           duration: log.duration,
//           status: log.status,
//           cost: log.cost,
//         }));
//         setCallLogs(formattedLogs);
//         setCallLogsPaginationInfo({
//           total_count: response.pagination?.total_count || 0,
//           total_pages: response.pagination?.total_pages || 0,
//         });
//       } else {
//         setCallLogs([]);
//       }
//     } catch (error) {
//       console.error("Error fetching call logs:", error);
//       setError(error.response?.data?.message || "Failed to fetch call logs. Please try again.");
//       setCallLogs([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchApiLogs = async () => {
//     setApiLogsLoading(true);
//     try {
//       const response = await apiClient.get("/api-logs", {
//         page: apiLogsPagination.pageIndex + 1,
//         page_size: apiLogsPagination.pageSize,
//       });

//       if (response?.status && Array.isArray(response.data)) {
//         // Map API response to UI format
//         const formattedApiLogs = response.data.map((log) => ({
//           id: log._id,
//           timestamp: formatApiLogTimestamp(log.timestamp),
//           endpoint: log.endpoint,
//           method: log.method,
//           statusCode: log.status,
//           responseTime: `${log.response_time_ms}ms`,
//           apiKey: log.api_key,
//           // Store full payload for detail view
//           payload: log.payload,
//         }));
//         setApiLogs(formattedApiLogs);
//         setApiLogsPaginationInfo({
//           total_count: response.pagination?.total_count || 0,
//           total_pages: response.pagination?.total_pages || 0,
//         });
//       } else {
//         setApiLogs([]);
//       }
//     } catch (error) {
//       console.error("Error fetching API logs:", error);
//       toast.error("Failed to load API logs");
//       setApiLogs([]);
//     } finally {
//       setApiLogsLoading(false);
//     }
//   };

//   const fetchErrorLogs = async () => {
//     setErrorLogsLoading(true);
//     try {
//       const response = await apiClient.get("/error-logs", {
//         page: errorLogsPagination.pageIndex + 1,
//         page_size: errorLogsPagination.pageSize,
//       });

//       if (response && response.status && Array.isArray(response.data)) {
//         // Map API response to UI format
//         const formattedErrorLogs = response.data.map((log) => ({
//           id: log._id,
//           timestamp: log.created_at ? new Date(log.created_at).toLocaleString() : "N/A",
//           errorType: log.error_module || "Unknown",
//           message: log.error_message || log.error_details || "No message",
//           severity: "Error", // Default severity since API doesn't provide it
//           source: log.error_module || "System",
//           // Store original fields for detail view
//           _original: log,
//         }));
//         setErrorLogsData(formattedErrorLogs);
//         setErrorLogsPaginationInfo({
//           total_count: response.pagination?.total_count || 0,
//           total_pages: response.pagination?.total_pages || 0,
//         });
//       } else {
//         setErrorLogsData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching error logs:", error);
//       setErrorLogsData([]);
//     } finally {
//       setErrorLogsLoading(false);
//     }
//   };

//   const handleViewDetails = async (log) => {
//     // For Call Logs tab (activeTab === 0), fetch detailed call log from API
//     if (activeTab === 0) {
//       setLoadingDetails(true);
//       try {
//         const response = await apiClient.get(`/call-logs/${log.id}/details`);

//         if (response?.data) {
//           dispatch(setModal({
//             type: "VIEW_CALL_LOG_DETAILS",
//             data: response.data
//           }));
//         }
//       } catch (error) {
//         console.error("Error fetching call log details:", error);
//         toast.error(error?.response?.data?.message || "Failed to load call log details");
//       } finally {
//         setLoadingDetails(false);
//       }
//     } else {
//       // For other tabs, use existing behavior
//       dispatch(setModal({ type: "VIEW_LOG_DETAILS", data: log }));
//     }
//   };

//   const handleExportLogs = () => {
//     alert("Exporting logs...");
//   };

//   const formatApiLogTimestamp = (dateString) => {
//     if (!dateString) return "N/A";

//     try {
//       const date = new Date(dateString);
//       return date.toLocaleString("en-US", {
//         year: "numeric",
//         month: "2-digit",
//         day: "2-digit",
//         hour: "2-digit",
//         minute: "2-digit",
//         second: "2-digit",
//       });
//     } catch (error) {
//       return dateString;
//     }
//   };

//   const getStatusColor = (status) => {
//     const colors = {
//       Completed: "success",
//       Transferred: "info",
//       Failed: "error",
//     };
//     return colors[status] || "default";
//   };

//   const getHttpStatusColor = (code) => {
//     if (code >= 200 && code < 300) return { bg: "#E8F5E9", color: "#2E7D32" };
//     if (code >= 400 && code < 500) return { bg: "#FFF3E0", color: "#E65100" };
//     if (code >= 500) return { bg: "#FFEBEE", color: "#C62828" };
//     return { bg: "#F5F5F5", color: "#666" };
//   };

//   const getSeverityColor = (severity) => {
//     const colors = {
//       Warning: { bg: "#FFF3E0", color: "#E65100" },
//       Error: { bg: "#FFEBEE", color: "#C62828" },
//       Critical: { bg: "#C62828", color: "#FFFFFF" },
//     };
//     return colors[severity] || { bg: "#F5F5F5", color: "#666" };
//   };

//   const callColumns = useMemo(
//     () => [
//       {
//         accessorKey: "timestamp",
//         header: "Timestamp",
//         size: 160,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 12 }}>
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       {
//         accessorKey: "callId",
//         header: "Call ID",
//         size: 140,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" fontWeight={600} sx={{ fontFamily: "monospace" }}>
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       {
//         accessorKey: "assistant",
//         header: "Assistant",
//         size: 180,
//       },
//       {
//         accessorKey: "phoneNumber",
//         header: "Phone Number",
//         size: 140,
//       },
//       {
//         accessorKey: "duration",
//         header: "Duration",
//         size: 100,
//       },
//       {
//         accessorKey: "status",
//         header: "Status",
//         size: 120,
//         Cell: ({ cell }) => (
//           <Chip
//             label={cell.getValue()}
//             size="small"
//             color={getStatusColor(cell.getValue())}
//             sx={{ fontWeight: 500 }}
//           />
//         ),
//       },
//       {
//         accessorKey: "cost",
//         header: "Cost",
//         size: 80,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" fontWeight={600} color="primary">
//             ${cell.getValue().toFixed(2)}
//           </Typography>
//         ),
//       },
//     ],
//     []
//   );

//   const apiColumns = useMemo(
//     () => [
//       {
//         accessorKey: "timestamp",
//         header: "Timestamp",
//         size: 180,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 12 }}>
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       {
//         accessorKey: "method",
//         header: "Method",
//         size: 90,
//         Cell: ({ cell }) => (
//           <Chip
//             label={cell.getValue()}
//             size="small"
//             sx={{
//               fontSize: 10,
//               height: 20,
//               backgroundColor: "#E3F2FD",
//               color: "#1565C0",
//               fontWeight: 600,
//             }}
//           />
//         ),
//       },
//       {
//         accessorKey: "endpoint",
//         header: "Endpoint",
//         size: 300,
//         Cell: ({ cell }) => (
//           <Typography
//             variant="body2"
//             sx={{
//               fontFamily: "monospace",
//               fontSize: 11,
//               overflow: "hidden",
//               textOverflow: "ellipsis",
//               whiteSpace: "nowrap",
//             }}
//           >
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       {
//         accessorKey: "statusCode",
//         header: "Status",
//         size: 90,
//         Cell: ({ cell }) => {
//           const colors = getHttpStatusColor(cell.getValue());
//           return (
//             <Chip
//               label={cell.getValue()}
//               size="small"
//               sx={{
//                 backgroundColor: colors.bg,
//                 color: colors.color,
//                 fontWeight: 600,
//               }}
//             />
//           );
//         },
//       },
//       {
//         accessorKey: "responseTime",
//         header: "Response Time",
//         size: 130,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" fontWeight={500}>
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       // {
//       //   accessorKey: "apiKey",
//       //   header: "API Key",
//       //   size: 180,
//       //   Cell: ({ cell }) => (
//       //     <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 11 }}>
//       //       {cell.getValue()}
//       //     </Typography>
//       //   ),
//       // },
//     ],
//     []
//   );

//   // Webhook columns commented out
//   // const webhookColumns = useMemo(
//   //   () => [
//   //     {
//   //       accessorKey: "timestamp",
//   //       header: "Timestamp",
//   //       size: 160,
//   //       Cell: ({ cell }) => (
//   //         <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 12 }}>
//   //           {cell.getValue()}
//   //         </Typography>
//   //       ),
//   //     },
//   //     {
//   //       accessorKey: "event",
//   //       header: "Event",
//   //       size: 150,
//   //       Cell: ({ cell }) => (
//   //         <Chip
//   //           label={cell.getValue()}
//   //           size="small"
//   //           sx={{
//   //             backgroundColor: "#F3E5F5",
//   //             color: "#7B1FA2",
//   //             fontWeight: 600,
//   //           }}
//   //         />
//   //       ),
//   //     },
//   //     {
//   //       accessorKey: "url",
//   //       header: "Webhook URL",
//   //       size: 280,
//   //       Cell: ({ cell }) => (
//   //         <Typography
//   //           variant="body2"
//   //           sx={{
//   //             fontFamily: "monospace",
//   //             fontSize: 11,
//   //             overflow: "hidden",
//   //             textOverflow: "ellipsis",
//   //             whiteSpace: "nowrap",
//   //           }}
//   //         >
//   //           {cell.getValue()}
//   //         </Typography>
//   //       ),
//   //     },
//   //     {
//   //       accessorKey: "statusCode",
//   //       header: "Status",
//   //       size: 80,
//   //       Cell: ({ cell }) => {
//   //         const colors = getHttpStatusColor(cell.getValue());
//   //         return (
//   //           <Chip
//   //             label={cell.getValue()}
//   //             size="small"
//   //             sx={{
//   //               backgroundColor: colors.bg,
//   //               color: colors.color,
//   //               fontWeight: 600,
//   //             }}
//   //           />
//   //         );
//   //       },
//   //     },
//   //     {
//   //       accessorKey: "responseTime",
//   //       header: "Response Time",
//   //       size: 120,
//   //     },
//   //     {
//   //       accessorKey: "retries",
//   //       header: "Retries",
//   //       size: 80,
//   //       Cell: ({ cell }) => (
//   //         <Typography
//   //           variant="body2"
//   //           fontWeight={600}
//   //           color={cell.getValue() > 0 ? "error.main" : "text.secondary"}
//   //         >
//   //           {cell.getValue()}
//   //         </Typography>
//   //       ),
//   //     },
//   //   ],
//   //   []
//   // );

//   const errorColumns = useMemo(
//     () => [
//       {
//         accessorKey: "timestamp",
//         header: "Timestamp",
//         size: 160,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 12 }}>
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       {
//         accessorKey: "severity",
//         header: "Severity",
//         size: 100,
//         Cell: ({ cell }) => {
//           const colors = getSeverityColor(cell.getValue());
//           return (
//             <Chip
//               label={cell.getValue()}
//               size="small"
//               sx={{
//                 backgroundColor: colors.bg,
//                 color: colors.color,
//                 fontWeight: 600,
//               }}
//             />
//           );
//         },
//       },
//       {
//         accessorKey: "errorType",
//         header: "Error Type",
//         size: 180,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" fontWeight={600}>
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       {
//         accessorKey: "message",
//         header: "Message",
//         size: 300,
//         Cell: ({ cell }) => (
//           <Typography variant="body2" color="text.secondary">
//             {cell.getValue()}
//           </Typography>
//         ),
//       },
//       {
//         accessorKey: "source",
//         header: "Source",
//         size: 140,
//       },
//     ],
//     []
//   );

//   const totalCallLogs = callLogsPaginationInfo.total_count;
//   const totalApiCalls = apiLogsPaginationInfo.total_count;
//   // const totalWebhooks = webhookLogs.length; // Webhook functionality commented out
//   const totalErrors = errorLogsPaginationInfo.total_count;

//   return (
//     <Box sx={{ padding: 3 }}>
//       <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
//         <Box>
//           <Typography variant="h4" gutterBottom fontWeight={600}>
//             Logs & Monitoring
//           </Typography>
//           <Typography variant="body1" color="text.secondary">
//             Track calls, API requests, webhooks, and system errors
//           </Typography>
//         </Box>
//         <Box sx={{ display: "flex", gap: 1 }}>
//           <CustomButton
//             icon={<FilterListIcon />}
//             iconPosition="left"
//             text="Filters"
//             variant="outlined"
//           />
//           <CustomButton
//             icon={<DownloadIcon />}
//             iconPosition="left"
//             text="Export Logs"
//             onClick={handleExportLogs}
//           />
//         </Box>
//       </Box>

//       <Box sx={{ display: "flex", gap: 2, mb: 3 }}>
//         <Box sx={{ flex: 1, p: 2, borderRadius: 2, backgroundColor: "#F3F4F6" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//             <PhoneIcon sx={{ color: "primary.main" }} />
//             <Typography variant="h4" fontWeight={700} color="primary">
//               {totalCallLogs}
//             </Typography>
//           </Box>
//           <Typography variant="body2" color="text.secondary">
//             Call Logs
//           </Typography>
//         </Box>
//         <Box sx={{ flex: 1, p: 2, borderRadius: 2, backgroundColor: "#F3F4F6" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//             <ApiIcon sx={{ color: "info.main" }} />
//             <Typography variant="h4" fontWeight={700} color="info.main">
//               {totalApiCalls}
//             </Typography>
//           </Box>
//           <Typography variant="body2" color="text.secondary">
//             API Requests
//           </Typography>
//         </Box>
//         {/* Webhook stats card commented out */}
//         {/* <Box sx={{ flex: 1, p: 2, borderRadius: 2, backgroundColor: "#F3F4F6" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//             <WebhookIcon sx={{ color: "success.main" }} />
//             <Typography variant="h4" fontWeight={700} color="success.main">
//               {totalWebhooks}
//             </Typography>
//           </Box>
//           <Typography variant="body2" color="text.secondary">
//             Webhook Events
//           </Typography>
//         </Box> */}
//         <Box sx={{ flex: 1, p: 2, borderRadius: 2, backgroundColor: "#F3F4F6" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//             <ErrorIcon sx={{ color: "error.main" }} />
//             <Typography variant="h4" fontWeight={700} color="error.main">
//               {totalErrors}
//             </Typography>
//           </Box>
//           <Typography variant="body2" color="text.secondary">
//             Errors
//           </Typography>
//         </Box>
//       </Box>

//       <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
//         <Tabs value={activeTab} onChange={(e, v) => setActiveTab(v)}>
//           <Tab label="Call Logs" />
//           <Tab label="API Logs" />
//           {/* <Tab label="Webhook Logs" /> */}
//           <Tab label="Error Logs" />
//         </Tabs>
//       </Box>

//       {activeTab === 0 && (
//         <>
//           {/* Error State */}
//           {error && !loading && (
//             <Alert severity="error" sx={{ mb: 2 }}>
//               {error}
//             </Alert>
//           )}

//           {/* Empty State */}
//           {!loading && !error && callLogs.length === 0 && (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 py: 8,
//                 px: 3,
//                 borderRadius: 2,
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#FAFAFA",
//               }}
//             >
//               <PhoneIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
//               <Typography variant="h6" color="text.secondary" gutterBottom>
//                 No Call Logs Found
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Call logs will appear here once calls are made.
//               </Typography>
//             </Box>
//           )}

//           {/* Loading State or Table with Data */}
//           {(loading || callLogs.length > 0) && (
//             <MaterialReactTable
//               columns={callColumns}
//               data={callLogs}
//               manualPagination
//               rowCount={callLogsPaginationInfo.total_count}
//               onPaginationChange={setCallLogsPagination}
//               state={{
//                 isLoading: loading,
//                 pagination: callLogsPagination,
//               }}
//               enableRowActions
//               positionActionsColumn="last"
//               renderRowActions={({ row }) => (
//                 <Box sx={{ display: "flex", gap: 0.5 }}>
//                   <Tooltip title="View Details">
//                     <IconButton
//                       size="small"
//                       onClick={() => handleViewDetails(row.original)}
//                       sx={{ color: "primary.main" }}
//                       disabled={loadingDetails}
//                     >
//                       {loadingDetails ? (
//                         <CircularProgress size={20} />
//                       ) : (
//                         <VisibilityIcon />
//                       )}
//                     </IconButton>
//                   </Tooltip>
//                 </Box>
//               )}
//               enableColumnFilters
//               enableGlobalFilter
//               enableSorting
//               enablePagination
//               muiTablePaginationProps={{
//                 showFirstButton: true,
//                 showLastButton: true,
//               }}
//               muiTablePaperProps={{
//                 elevation: 0,
//                 sx: {
//                   borderRadius: 2,
//                   border: "1px solid #E0E0E0",
//                 },
//               }}
//             />
//           )}
//         </>
//       )}

//       {activeTab === 1 && (
//         <>
//           {/* Empty State */}
//           {!apiLogsLoading && apiLogs.length === 0 && (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 py: 8,
//                 px: 3,
//                 borderRadius: 2,
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#FAFAFA",
//               }}
//             >
//               <ApiIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
//               <Typography variant="h6" color="text.secondary" gutterBottom>
//                 No API Logs Found
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 API logs will appear here once API calls are made.
//               </Typography>
//             </Box>
//           )}

//           {/* Loading State or Table with Data */}
//           {(apiLogsLoading || apiLogs.length > 0) && (
//             <MaterialReactTable
//               columns={apiColumns}
//               data={apiLogs}
//               manualPagination
//               rowCount={apiLogsPaginationInfo.total_count}
//               onPaginationChange={setApiLogsPagination}
//               state={{
//                 isLoading: apiLogsLoading,
//                 pagination: apiLogsPagination,
//               }}
//               enableRowActions
//               positionActionsColumn="last"
//               renderRowActions={({ row }) => (
//                 <Box sx={{ display: "flex", gap: 0.5 }}>
//                   <Tooltip title="View Details">
//                     <IconButton
//                       size="small"
//                       onClick={() => handleViewDetails(row.original)}
//                       sx={{ color: "primary.main" }}
//                     >
//                       <VisibilityIcon />
//                     </IconButton>
//                   </Tooltip>
//                 </Box>
//               )}
//               enableColumnFilters
//               enableGlobalFilter
//               enableSorting
//               enablePagination
//               muiTablePaginationProps={{
//                 showFirstButton: true,
//                 showLastButton: true,
//               }}
//               muiTablePaperProps={{
//                 elevation: 0,
//                 sx: {
//                   borderRadius: 2,
//                   border: "1px solid #E0E0E0",
//                 },
//               }}
//             />
//           )}
//         </>
//       )}

//       {/* Webhook Logs table commented out */}
//       {/* {activeTab === 2 && (
//         <MaterialReactTable
//           columns={webhookColumns}
//           data={webhookLogs}
//           state={{ isLoading: loading }}
//           enableRowActions
//           positionActionsColumn="last"
//           renderRowActions={({ row }) => (
//             <Box sx={{ display: "flex", gap: 0.5 }}>
//               <Tooltip title="View Details">
//                 <IconButton
//                   size="small"
//                   onClick={() => handleViewDetails(row.original)}
//                   sx={{ color: "primary.main" }}
//                 >
//                   <VisibilityIcon />
//                 </IconButton>
//               </Tooltip>
//             </Box>
//           )}
//           enableColumnFilters
//           enableGlobalFilter
//           enableSorting
//           enablePagination
//           initialState={{
//             pagination: { pageSize: 10, pageIndex: 0 },
//           }}
//           muiTablePaperProps={{
//             elevation: 0,
//             sx: {
//               borderRadius: 2,
//               border: "1px solid #E0E0E0",
//             },
//           }}
//         />
//       )} */}

//       {activeTab === 2 && (
//         <>
//           {/* Empty State */}
//           {!errorLogsLoading && errorLogsData.length === 0 && (
//             <Box
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 py: 8,
//                 px: 3,
//                 borderRadius: 2,
//                 border: "1px solid #E0E0E0",
//                 backgroundColor: "#FAFAFA",
//               }}
//             >
//               <ErrorIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
//               <Typography variant="h6" color="text.secondary" gutterBottom>
//                 No Error Logs Found
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 Error logs will appear here when system errors occur.
//               </Typography>
//             </Box>
//           )}

//           {/* Loading State or Table with Data */}
//           {(errorLogsLoading || errorLogsData.length > 0) && (
//             <MaterialReactTable
//               columns={errorColumns}
//               data={errorLogsData}
//               manualPagination
//               rowCount={errorLogsPaginationInfo.total_count}
//               onPaginationChange={setErrorLogsPagination}
//               state={{
//                 isLoading: errorLogsLoading,
//                 pagination: errorLogsPagination,
//               }}
//               enableRowActions
//               positionActionsColumn="last"
//               renderRowActions={({ row }) => (
//                 <Box sx={{ display: "flex", gap: 0.5 }}>
//                   <Tooltip title="View Details">
//                     <IconButton
//                       size="small"
//                       onClick={() => handleViewDetails(row.original)}
//                       sx={{ color: "primary.main" }}
//                     >
//                       <VisibilityIcon />
//                     </IconButton>
//                   </Tooltip>
//                 </Box>
//               )}
//               enableColumnFilters
//               enableGlobalFilter
//               enableSorting
//               enablePagination
//               muiTablePaginationProps={{
//                 showFirstButton: true,
//                 showLastButton: true,
//               }}
//               muiTablePaperProps={{
//                 elevation: 0,
//                 sx: {
//                   borderRadius: 2,
//                   border: "1px solid #E0E0E0",
//                 },
//               }}
//             />
//           )}
//         </>
//       )}
//     </Box>
//   );
// };

// export default Logs;


import React, { useEffect, useMemo, useState } from "react";
import { Box, Typography, Chip, IconButton, Tooltip, Tabs, Tab, CircularProgress, Alert } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useDispatch, useSelector } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import FilterListIcon from "@mui/icons-material/FilterList";
import PhoneIcon from "@mui/icons-material/Phone";
import ApiIcon from "@mui/icons-material/Api";
// import WebhookIcon from "@mui/icons-material/Webhook"; // Webhook functionality commented out
import ErrorIcon from "@mui/icons-material/Error";
import { setModal } from "../../features/modal/ModalSlice";
import CustomButton from "../../components/Button/CustomButton";
import apiClient from "../../services/apiClient";
import toast from "react-hot-toast";

const Logs = () => {
  const dispatch = useDispatch();
  const modal = useSelector((state) => state.modal?.modal);
  const [activeTab, setActiveTab] = useState(0);

 
  const [callLogs, setCallLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  const [callLogsPagination, setCallLogsPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [callLogsPaginationInfo, setCallLogsPaginationInfo] = useState({
    total_count: 0,
    total_pages: 0,
  });


  const [errorLogsData, setErrorLogsData] = useState([]);
  const [errorLogsLoading, setErrorLogsLoading] = useState(false);

  
  const [errorLogsPagination, setErrorLogsPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [errorLogsPaginationInfo, setErrorLogsPaginationInfo] = useState({
    total_count: 0,
    total_pages: 0,
  });


  const [apiLogs, setApiLogs] = useState([]);
  const [apiLogsLoading, setApiLogsLoading] = useState(false);


  const [apiLogsPagination, setApiLogsPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [apiLogsPaginationInfo, setApiLogsPaginationInfo] = useState({
    total_count: 0,
    total_pages: 0,
  });


  const [loadingDetails, setLoadingDetails] = useState(false);



  // Fetch Call Logs from API
  useEffect(() => {
    fetchCallLogs();
  }, [callLogsPagination.pageIndex, callLogsPagination.pageSize]);

  // Fetch API Logs when tab changes to API Logs
  useEffect(() => {
    if (activeTab === 1) {
      fetchApiLogs();
    }
  }, [activeTab, apiLogsPagination.pageIndex, apiLogsPagination.pageSize]);

  // Fetch Error Logs when tab changes to Error Logs
  useEffect(() => {
    if (activeTab === 2) {
      fetchErrorLogs();
    }
  }, [activeTab, errorLogsPagination.pageIndex, errorLogsPagination.pageSize]);

  useEffect(() => {
    if (modal?.isUpdatedIn === "LOGS") {
      fetchCallLogs();
      if (activeTab === 1) {
        fetchApiLogs();
      }
      if (activeTab === 2) {
        fetchErrorLogs();
      }
    }
  }, [modal, activeTab]);

  const fetchCallLogs = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await apiClient.get("/call-logs", {
        page: callLogsPagination.pageIndex + 1,
        page_size: callLogsPagination.pageSize,
      });

      if (response.status && response.data) {
        // Map API response to UI format
        const formattedLogs = response.data.map((log) => ({
          id: log._id,
          timestamp: log.timestamp || log.created_at,
          callId: log.call_id,
          assistant: log.assistant,
          phoneNumber: log.phone_number,
          duration: log.duration,
          status: log.status,
          cost: log.cost,
        }));
        setCallLogs(formattedLogs);
        setCallLogsPaginationInfo({
          total_count: response.pagination?.total_count || 0,
          total_pages: response.pagination?.total_pages || 0,
        });
      } else {
        setCallLogs([]);
      }
    } catch (error) {
      console.error("Error fetching call logs:", error);
      setError(error.response?.data?.message || "Failed to fetch call logs. Please try again.");
      setCallLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchApiLogs = async () => {
    setApiLogsLoading(true);
    try {
      const response = await apiClient.get("/api-logs", {
        page: apiLogsPagination.pageIndex + 1,
        page_size: apiLogsPagination.pageSize,
      });

      if (response?.status && Array.isArray(response.data)) {
        // Map API response to UI format
        const formattedApiLogs = response.data.map((log) => ({
          id: log._id,
          timestamp: formatApiLogTimestamp(log.timestamp),
          endpoint: log.endpoint,
          method: log.method,
          statusCode: log.status,
          responseTime: `${log.response_time_ms}ms`,
          apiKey: log.api_key,
          // Store full payload for detail view
          payload: log.payload,
        }));
        setApiLogs(formattedApiLogs);
        setApiLogsPaginationInfo({
          total_count: response.pagination?.total_count || 0,
          total_pages: response.pagination?.total_pages || 0,
        });
      } else {
        setApiLogs([]);
      }
    } catch (error) {
      console.error("Error fetching API logs:", error);
      toast.error("Failed to load API logs");
      setApiLogs([]);
    } finally {
      setApiLogsLoading(false);
    }
  };

  const fetchErrorLogs = async () => {
    setErrorLogsLoading(true);
    try {
      const response = await apiClient.get("/error-logs", {
        page: errorLogsPagination.pageIndex + 1,
        page_size: errorLogsPagination.pageSize,
      });

      if (response && response.status && Array.isArray(response.data)) {
        // Map API response to UI format
        const formattedErrorLogs = response.data.map((log) => ({
          id: log._id,
          timestamp: log.created_at ? new Date(log.created_at).toLocaleString() : "N/A",
          errorType: log.error_module || "Unknown",
          message: log.error_message || log.error_details || "No message",
          severity: "Error", // Default severity since API doesn't provide it
          source: log.error_module || "System",
          // Store original fields for detail view
          _original: log,
        }));
        setErrorLogsData(formattedErrorLogs);
        setErrorLogsPaginationInfo({
          total_count: response.pagination?.total_count || 0,
          total_pages: response.pagination?.total_pages || 0,
        });
      } else {
        setErrorLogsData([]);
      }
    } catch (error) {
      console.error("Error fetching error logs:", error);
      setErrorLogsData([]);
    } finally {
      setErrorLogsLoading(false);
    }
  };

  const handleViewDetails = async (log) => {
    // For Call Logs tab (activeTab === 0), fetch detailed call log from API
    if (activeTab === 0) {
      setLoadingDetails(true);
      try {
        const response = await apiClient.get(`/call-logs/${log.id}/details`);

        if (response?.data) {
          dispatch(setModal({
            type: "VIEW_CALL_LOG_DETAILS",
            data: response.data
          }));
        }
      } catch (error) {
        console.error("Error fetching call log details:", error);
        toast.error(error?.response?.data?.message || "Failed to load call log details");
      } finally {
        setLoadingDetails(false);
      }
    } else if (activeTab === 2) {
      // For Error Logs tab (activeTab === 2), fetch detailed error log from API
      setLoadingDetails(true);
      try {
        const response = await apiClient.get(`/error-logs/${log.id}`);

        if (response?.data) {
          dispatch(setModal({
            type: "VIEW_ERROR_LOG_DETAILS",
            data: response
          }));
        }
      } catch (error) {
        console.error("Error fetching error log details:", error);
        toast.error(error?.response?.data?.message || "Failed to load error log details");
      } finally {
        setLoadingDetails(false);
      }
    } else {
      // For other tabs, use existing behavior
      dispatch(setModal({ type: "VIEW_LOG_DETAILS", data: log }));
    }
  };

  const handleExportLogs = () => {
    alert("Exporting logs...");
  };

  const formatApiLogTimestamp = (dateString) => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);
      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    } catch (error) {
      return dateString;
    }
  };

  const getStatusColor = (status) => {
    const colors = {
      Completed: "success",
      Transferred: "info",
      Failed: "error",
    };
    return colors[status] || "default";
  };

  const getHttpStatusColor = (code) => {
    if (code >= 200 && code < 300) return { bg: "#E8F5E9", color: "#2E7D32" };
    if (code >= 400 && code < 500) return { bg: "#FFF3E0", color: "#E65100" };
    if (code >= 500) return { bg: "#FFEBEE", color: "#C62828" };
    return { bg: "#F5F5F5", color: "#666" };
  };

  const getSeverityColor = (severity) => {
    const colors = {
      Warning: { bg: "#FFF3E0", color: "#E65100" },
      Error: { bg: "#FFEBEE", color: "#C62828" },
      Critical: { bg: "#C62828", color: "#FFFFFF" },
    };
    return colors[severity] || { bg: "#F5F5F5", color: "#666" };
  };

  const callColumns = useMemo(
    () => [
      {
        accessorKey: "timestamp",
        header: "Timestamp",
        size: 160,
        Cell: ({ cell }) => (
          <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 12 }}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "callId",
        header: "Call ID",
        size: 140,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={600} sx={{ fontFamily: "monospace" }}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "assistant",
        header: "Assistant",
        size: 180,
      },
      {
        accessorKey: "phoneNumber",
        header: "Phone Number",
        size: 140,
      },
      {
        accessorKey: "duration",
        header: "Duration",
        size: 100,
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 120,
        Cell: ({ cell }) => (
          <Chip
            label={cell.getValue()}
            size="small"
            color={getStatusColor(cell.getValue())}
            sx={{ fontWeight: 500 }}
          />
        ),
      },
      {
        accessorKey: "cost",
        header: "Cost",
        size: 80,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={600} color="primary">
            ${cell.getValue().toFixed(2)}
          </Typography>
        ),
      },
    ],
    []
  );

  const apiColumns = useMemo(
    () => [
      {
        accessorKey: "timestamp",
        header: "Timestamp",
        size: 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 12 }}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "method",
        header: "Method",
        size: 90,
        Cell: ({ cell }) => (
          <Chip
            label={cell.getValue()}
            size="small"
            sx={{
              fontSize: 10,
              height: 20,
              backgroundColor: "#E3F2FD",
              color: "#1565C0",
              fontWeight: 600,
            }}
          />
        ),
      },
      {
        accessorKey: "endpoint",
        header: "Endpoint",
        size: 300,
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            sx={{
              fontFamily: "monospace",
              fontSize: 11,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "statusCode",
        header: "Status",
        size: 90,
        Cell: ({ cell }) => {
          const colors = getHttpStatusColor(cell.getValue());
          return (
            <Chip
              label={cell.getValue()}
              size="small"
              sx={{
                backgroundColor: colors.bg,
                color: colors.color,
                fontWeight: 600,
              }}
            />
          );
        },
      },
      {
        accessorKey: "responseTime",
        header: "Response Time",
        size: 130,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={500}>
            {cell.getValue()}
          </Typography>
        ),
      },
      // {
      //   accessorKey: "apiKey",
      //   header: "API Key",
      //   size: 180,
      //   Cell: ({ cell }) => (
      //     <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 11 }}>
      //       {cell.getValue()}
      //     </Typography>
      //   ),
      // },
    ],
    []
  );



  const errorColumns = useMemo(
    () => [
      {
        accessorKey: "timestamp",
        header: "Timestamp",
        size: 160,
        Cell: ({ cell }) => (
          <Typography variant="body2" sx={{ fontFamily: "monospace", fontSize: 12 }}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "severity",
        header: "Severity",
        size: 100,
        Cell: ({ cell }) => {
          const colors = getSeverityColor(cell.getValue());
          return (
            <Chip
              label={cell.getValue()}
              size="small"
              sx={{
                backgroundColor: colors.bg,
                color: colors.color,
                fontWeight: 600,
              }}
            />
          );
        },
      },
      {
        accessorKey: "errorType",
        header: "Error Type",
        size: 180,
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={600}>
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "message",
        header: "Message",
        size: 300,
        Cell: ({ cell }) => (
          <Typography variant="body2" color="text.secondary">
            {cell.getValue()}
          </Typography>
        ),
      },
      {
        accessorKey: "source",
        header: "Source",
        size: 140,
      },
    ],
    []
  );

  const totalCallLogs = callLogsPaginationInfo.total_count;
  const totalApiCalls = apiLogsPaginationInfo.total_count;
  // const totalWebhooks = webhookLogs.length; // Webhook functionality commented out
  const totalErrors = errorLogsPaginationInfo.total_count;

  return (
    <Box>
      {/* Header Section - White Background */}
      <Box sx={{
        backgroundColor: "#FFFFFF",
        borderBottom: "1px solid #E5E7EB",
        px: 4,
        py: 3
      }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box>
            <Typography variant="h5" fontWeight={600} color="#111827" sx={{ mb: 0.5 }}>
              Logs & Monitoring
            </Typography>
            <Typography variant="body2" color="#6B7280">
              Track calls, API requests, webhooks, and system errors
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1 }}>
            <CustomButton
              icon={<FilterListIcon />}
              iconPosition="left"
              text="Filters"
              variant="outlined"
            />
            <CustomButton
              icon={<DownloadIcon />}
              iconPosition="left"
              text="Export Logs"
              onClick={handleExportLogs}
            />
          </Box>
        </Box>
      </Box>

      {/* Stats Cards Section - Separate */}
      <Box sx={{ px: 4, pt: 3, pb: 2 }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Box sx={{
            flex: 1,
            px: 3,
            py: 2.5,
            borderRadius: 2,
            backgroundColor: "#FFFFFF",
            border: "1px solid #E5E7EB",
            transition: "all 0.2s",
            "&:hover": {
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
            }
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <PhoneIcon sx={{ color: "#111827", fontSize: 20 }} />
              <Typography variant="h5" fontWeight={600} color="#111827">
                {totalCallLogs}
              </Typography>
            </Box>
            <Typography variant="caption" color="#6B7280" sx={{ fontSize: "0.75rem" }}>
              Call Logs
            </Typography>
          </Box>
          <Box sx={{
            flex: 1,
            px: 3,
            py: 2.5,
            borderRadius: 2,
            backgroundColor: "#FFFFFF",
            border: "1px solid #E5E7EB",
            transition: "all 0.2s",
            "&:hover": {
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
            }
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <ApiIcon sx={{ color: "#3B82F6", fontSize: 20 }} />
              <Typography variant="h5" fontWeight={600} color="#3B82F6">
                {totalApiCalls}
              </Typography>
            </Box>
            <Typography variant="caption" color="#6B7280" sx={{ fontSize: "0.75rem" }}>
              API Requests
            </Typography>
          </Box>
          <Box sx={{
            flex: 1,
            px: 3,
            py: 2.5,
            borderRadius: 2,
            backgroundColor: "#FFFFFF",
            border: "1px solid #E5E7EB",
            transition: "all 0.2s",
            "&:hover": {
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
            }
          }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <ErrorIcon sx={{ color: "#EF4444", fontSize: 20 }} />
              <Typography variant="h5" fontWeight={600} color="#EF4444">
                {totalErrors}
              </Typography>
            </Box>
            <Typography variant="caption" color="#6B7280" sx={{ fontSize: "0.75rem" }}>
              Errors
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Content Section */}
      <Box sx={{ px: 4, pb: 3 }}>
        <Box sx={{
          backgroundColor: "#FFFFFF",
          borderRadius: 2,
          border: "1px solid #E5E7EB",
          overflow: "hidden"
        }}>
          <Box sx={{ borderBottom: 1, borderColor: "#E5E7EB" }}>
            <Tabs
              value={activeTab}
              onChange={(e, v) => setActiveTab(v)}
              sx={{
                px: 2,
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 500,
                  fontSize: '0.875rem',
                  color: '#6B7280',
                  '&.Mui-selected': {
                    color: '#111827',
                  }
                }
              }}
            >
              <Tab label="Call Logs" />
              <Tab label="API Logs" />
              <Tab label="Error Logs" />
            </Tabs>
          </Box>

          <Box sx={{ p: 2 }}>

      {activeTab === 0 && (
        <>
          {/* Error State */}
          {error && !loading && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {/* Empty State */}
          {!loading && !error && callLogs.length === 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 8,
                px: 3,
                borderRadius: 2,
                border: "1px solid #E0E0E0",
                backgroundColor: "#FAFAFA",
              }}
            >
              <PhoneIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No Call Logs Found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Call logs will appear here once calls are made.
              </Typography>
            </Box>
          )}

          {/* Loading State or Table with Data */}
          {(loading || callLogs.length > 0) && (
            <MaterialReactTable
              columns={callColumns}
              data={callLogs}
              manualPagination
              rowCount={callLogsPaginationInfo.total_count}
              onPaginationChange={setCallLogsPagination}
              state={{
                isLoading: loading,
                pagination: callLogsPagination,
              }}
              enableRowActions
              positionActionsColumn="last"
              renderRowActions={({ row }) => (
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  <Tooltip title="View Details">
                    <IconButton
                      size="small"
                      onClick={() => handleViewDetails(row.original)}
                      sx={{ color: "primary.main" }}
                      disabled={loadingDetails}
                    >
                      {loadingDetails ? (
                        <CircularProgress size={20} />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              enableColumnFilters
              enableGlobalFilter
              enableSorting
              enablePagination
              muiTablePaginationProps={{
                showFirstButton: true,
                showLastButton: true,
              }}
              muiTablePaperProps={{
                elevation: 0,
                sx: {
                  borderRadius: 2,
                  border: "1px solid #E0E0E0",
                },
              }}
            />
          )}
        </>
      )}

      {activeTab === 1 && (
        <>
          {/* Empty State */}
          {!apiLogsLoading && apiLogs.length === 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 8,
                px: 3,
                borderRadius: 2,
                border: "1px solid #E0E0E0",
                backgroundColor: "#FAFAFA",
              }}
            >
              <ApiIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No API Logs Found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                API logs will appear here once API calls are made.
              </Typography>
            </Box>
          )}

          {/* Loading State or Table with Data */}
          {(apiLogsLoading || apiLogs.length > 0) && (
            <MaterialReactTable
              columns={apiColumns}
              data={apiLogs}
              manualPagination
              rowCount={apiLogsPaginationInfo.total_count}
              onPaginationChange={setApiLogsPagination}
              state={{
                isLoading: apiLogsLoading,
                pagination: apiLogsPagination,
              }}
              enableRowActions
              positionActionsColumn="last"
              renderRowActions={({ row }) => (
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  <Tooltip title="View Details">
                    <IconButton
                      size="small"
                      onClick={() => handleViewDetails(row.original)}
                      sx={{ color: "primary.main" }}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              enableColumnFilters
              enableGlobalFilter
              enableSorting
              enablePagination
              muiTablePaginationProps={{
                showFirstButton: true,
                showLastButton: true,
              }}
              muiTablePaperProps={{
                elevation: 0,
                sx: {
                  borderRadius: 2,
                  border: "1px solid #E0E0E0",
                },
              }}
            />
          )}
        </>
      )}

     

      {activeTab === 2 && (
        <>
          {/* Empty State */}
          {!errorLogsLoading && errorLogsData.length === 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 8,
                px: 3,
                borderRadius: 2,
                border: "1px solid #E0E0E0",
                backgroundColor: "#FAFAFA",
              }}
            >
              <ErrorIcon sx={{ fontSize: 64, color: "text.secondary", mb: 2 }} />
              <Typography variant="h6" color="text.secondary" gutterBottom>
                No Error Logs Found
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Error logs will appear here when system errors occur.
              </Typography>
            </Box>
          )}

          {/* Loading State or Table with Data */}
          {(errorLogsLoading || errorLogsData.length > 0) && (
            <MaterialReactTable
              columns={errorColumns}
              data={errorLogsData}
              manualPagination
              rowCount={errorLogsPaginationInfo.total_count}
              onPaginationChange={setErrorLogsPagination}
              state={{
                isLoading: errorLogsLoading,
                pagination: errorLogsPagination,
              }}
              enableRowActions
              positionActionsColumn="last"
              renderRowActions={({ row }) => (
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  <Tooltip title="View Details">
                    <IconButton
                      size="small"
                      onClick={() => handleViewDetails(row.original)}
                      sx={{ color: "primary.main" }}
                      disabled={loadingDetails}
                    >
                      {loadingDetails ? (
                        <CircularProgress size={20} />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
              )}
              enableColumnFilters
              enableGlobalFilter
              enableSorting
              enablePagination
              muiTablePaginationProps={{
                showFirstButton: true,
                showLastButton: true,
              }}
              muiTablePaperProps={{
                elevation: 0,
                sx: {
                  borderRadius: 0,
                  border: "none",
                  boxShadow: "none"
                },
              }}
              muiTableBodyProps={{
                sx: {
                  '& tr:hover': {
                    backgroundColor: '#F9FAFB',
                  },
                },
              }}
            />
          )}
        </>
      )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Logs;
